export class PopupBlockerError extends Error {
    constructor(message?: string) {
        super(`Popup is blocked: ${message}`);
    }
}